/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Loadmore1Inputs */

const zh_common_loadmore1 = /** @type {(inputs: Common_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加载更多`)
};

const en_common_loadmore1 = /** @type {(inputs: Common_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Load More`)
};

const es_common_loadmore1 = /** @type {(inputs: Common_Loadmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargar más`)
};

/**
* | output |
* | --- |
* | "Load More" |
*
* @param {Common_Loadmore1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const common_loadmore1 = /** @type {((inputs?: Common_Loadmore1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Loadmore1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_common_loadmore1(inputs)
	if (locale === "en") return en_common_loadmore1(inputs)
	return es_common_loadmore1(inputs)
});
export { common_loadmore1 as "common_loadMore" }